collectSpecifierPaths